import { Datatable, SearchHeader, SubHeader } from "../../../../common";
import { deleteCompany, getCompanies } from "../../../../../api";
import { useLanguage } from "../../../../../context";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../../Libraries";
import { useEffect, useState } from "react";

const CompanyList = () => {
    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        resultsPerPage: 10,
        totalCount: 0,
        page: 1,
    });

    useEffect(() => {
        handleCompanies();
    }, []);

    const onDelete = async (id) => {
        try {
            const data = await deleteCompany(id, { archive: true });
            if (data.success) handleCompanies();
        } catch (err) { }
    };

    const handleCompanies = async (reqPage = 1, filters = undefined) => {
        try {
            setLoading(true);

            let params = {
                resultsPerPage: pagination.resultsPerPage,
                page: reqPage
            };

            if (filters) params = { ...params, ...filters };

            const { data } = await getCompanies(params);
            const { resultsPerPage, totalCount, companies, page } = data || {};

            setPagination({ resultsPerPage, totalCount, page });
            setList(companies.map(company => {
                return {
                    nameLocal: company.nameLocal || '-',
                    country: company?.country || '-',
                    address: company?.address || '',
                    createdAt: company.createdAt,
                    image: company?.image || '',
                    phone: company?.phone || '',
                    name: company.name || '',
                    _id: company._id,
                }
            }));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (page) => {
        if (page == pagination.current || loading) return;
        handleCompanies(page);
    };

    const AddCompany = () => navigate('/store-list/create');

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        subTitle: 'manage_ur_company',
                        title: 'company_list',
                        overlays: [
                            {
                                svg: 'assets/img/icons/pdf.svg',
                                tipType: I18n.pdf
                            },
                            {
                                svg: 'assets/img/icons/excel.svg',
                                tipType: I18n.excel
                            },
                            {
                                onClick: handleCompanies,
                                Icon: Icon['referesh'],
                                tipType: I18n.refresh,
                                disabled: loading
                            }
                        ],
                        actions: [
                            {
                                className: 'btn btn-added',
                                title: 'add_new_company',
                                action: AddCompany,
                                icon: 'plus',

                            }
                        ],
                    }}
                />

                <div className="card table-list-card">
                    <div className="card-body">
                        <SearchHeader applyFilter={handleCompanies} />

                        <div className="table-responsive">
                            <Datatable
                                onPageChange={onPageChange}
                                pagination={pagination}
                                onDelete={onDelete}
                                loading={loading}
                                dataSource={list}
                                type="store-list"
                                noOfColumns={5}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompanyList;